import { Box } from '@mui/material'
import styles from './BoardsSection.module.scss'
import { BOARDS_HEIGHT_MAX, BOARDS_HEIGHT_MIN } from './boardsSectionTokens.js'

export function BoardsSectionResizeHandle({ resize }) {
  return (
    <Box
      className={styles.resizeHandle}
      role="separator"
      tabIndex={0}
      aria-orientation="horizontal"
      aria-label="Resize boards section height from the bottom border. Use arrow keys to adjust."
      aria-valuemin={BOARDS_HEIGHT_MIN}
      aria-valuemax={BOARDS_HEIGHT_MAX}
      aria-valuenow={resize.boardsHeightPx}
      onPointerDown={resize.onResizePointerDown}
      onPointerMove={resize.onResizePointerMove}
      onPointerUp={resize.onResizePointerUp}
      onPointerCancel={resize.onResizePointerUp}
      onKeyDown={resize.onResizeKeyDown}
    />
  )
}
